enum SectionLocation {
    BoxLocation = "1",
    Indoors = "2",
    Outdoors = "3"
}

export default SectionLocation;